/**
 *
 * Usage:
 *
 *   data-sw-pattern
 *   pattern="<REGEX_PATTERN_TO_MATCH>" error class applied on fail 
 *
 *   -- Optional Attrs --
 *   date-sw-pattern-error-class="<SOME_ERROR_CLASS>"
 *   data-sw-pattern-error-message-class="<SOME_ERROR_CLASS_FOR_THE_MESSAGE_ELEMENT>"
 *
 */

var _ = require('underscore');
var $ = require('./../sw-jquery');
var errorTemplate = require('rrTags/errors/templates/tpl.sw-pattern-error.mustache');

var defaultErrorClass = 'error';
var defaultErrorElementClass = 'sw--is-text-error';

var uniqueErrorIdAttr = 'data-sw-pattern-error-id';
var errorElementAttr = 'data-sw-pattern-error-element';

function getErrorId($el, swPatternData) {
  var errorId;

  if(_.isEmpty(swPatternData.errorId)) {
    errorId = _.uniqueId('patternError_');
    $el.attr(uniqueErrorIdAttr, errorId);
  } else {
    errorId = swPatternData.errorId;
  }

  return errorId;
}

function getErrorMessageElement(errorId) {
  return $('[' + errorElementAttr + '][' + uniqueErrorIdAttr + '=' + errorId + ']');
}

function showErrorElement($el, swPatternData) {
  var errorId = getErrorId($el, swPatternData);
  var title = $el.attr('title');
  var $errorMessElement = getErrorMessageElement(errorId);

  if($errorMessElement.length < 1) {
    $el.after(errorTemplate.render({
      classes: !_.isUndefined(swPatternData.errorMessageClass) ? swPatternData.errorMessageClass : defaultErrorElementClass,
      errorId: errorId,
      message: title
    }));
  } else {
    $errorMessElement.show();
  }
}

function shouldShowError($el) {
  var title = $el.attr('title');
  return !_.isUndefined(title);
}

function showError($el, swPatternData) {
  if(shouldShowError($el)) {
    showErrorElement($el, swPatternData);
  }
}

function hideError($el, swPatternData) {
  var errorId;
  var $errorMessElement;
  if(shouldShowError($el, swPatternData)) {
    errorId = getErrorId($el, swPatternData);
    $errorMessElement = getErrorMessageElement(errorId);
    $errorMessElement.hide();
  }
}

$(function() {
  $('body').on('input', '[data-sw-pattern]', function() {
    var $el = $(this);
    var swPatternData = $el.swDataParams('swPattern', { excludePrefix: true });
    var errorClassToSet = !_.isUndefined(swPatternData.errorClass) ? swPatternData.errorClass : defaultErrorClass;

    if (!$el.swValidatePattern()) {
      $el.addClass(errorClassToSet);
      showError($el, swPatternData);
    } else {
    	$el.removeClass(errorClassToSet);
      hideError($el, swPatternData);
    }
  });
});
